import { Chip } from '@mui/material';
import dayjs from 'dayjs';

const formatDate = (value) => (value ? dayjs(value).format('DD MMM YYYY') : '—');

export const inactiveCroStudentsHeaderFn = () => [
  { field: 'sl_no', headerName: 'Sl No', width: 90 },
  { field: 'admn_no', headerName: 'Admission No', width: 180, sortable: true },
  { field: 'student_name', headerName: 'Student Name', width: 260, toolTipGetter: true, sortable: true },
  { field: 'student_mob_no', headerName: 'Phone Number', width: 170, sortable: true },
  { field: 'class_name', headerName: 'Class', width: 120 },
  { field: 'course_name', headerName: 'Course', width: 280, toolTipGetter: true, sortable: true },
  {
    field: 'course_status',
    headerName: 'Student Status',
    width: 190,
    sortable: true,
    renderCell: ({ row, value }) => (
      <Chip
        size="small"
        label={value || '—'}
        variant="outlined"
        color={row?.course_enrollment_status === 1 ? 'success' : row?.course_enrollment_status === 2 ? 'warning' : 'error'}
      />
    ),
  },
  {
    field: 'admission_confirmed_on',
    headerName: 'Admission Confirmed On',
    width: 220,
    sortable: true,
    valueGetter: ({ value }) => formatDate(value),
  },
  { field: 'owner', headerName: 'Owner', width: 220, toolTipGetter: true, sortable: true },
  {
    field: 'ownerStatus',
    headerName: 'Owner Status',
    width: 170,
    sortable: true,
    renderCell: ({ value }) => (
      <Chip
        size="small"
        label={Number(value) === 1 ? 'Active' : 'Inactive'}
        variant="outlined"
        color={Number(value) === 1 ? 'success' : 'error'}
      />
    ),
  },
  {
    field: 'owner_exit_date',
    headerName: 'Owner Exit Date',
    width: 190,
    valueGetter: ({ value }) => formatDate(value),
  },
  { field: 'current_cro', headerName: 'Current CRO', width: 220, toolTipGetter: true, sortable: true },
  {
    field: 'course_inactive_date',
    headerName: 'Student Inactive Date',
    width: 200,
    valueGetter: ({ value }) => formatDate(value),
  },
  //ACTIONS. THE TWO ARE MUTUALLY EXCLUSIVE BY DESIGN: ACTIVATING AN ALREADY ACTIVE STUDENT IS A
  //NO-OP, AND A STUDENT MUST BE ACTIVE BEFORE THEY CAN BE HANDED TO A CRO . SO AN INACTIVE ROW
  //OFFERS ONLY "MAKE ACTIVE" , AND ONCE ACTIVE ONLY "ASSIGN CRO"
  {
    field: 'activate',
    headerName: 'Make Active',
    width: 170,
    type: 'action',
    actionType: 'edit',
    actionKey: 'activate student',
    buttonName: 'Make Active',
    icon: 'mdi:account-check-outline',
    isDisabled: ({ row }) => row?.course_enrollment_status === 1,
    toolTipGetter: ({ row }) =>
      row?.course_enrollment_status === 1 ? 'Student is already active' : 'Set this student back to active',
  },
  {
    field: 'assign_cro',
    headerName: 'Assign CRO',
    width: 170,
    type: 'action',
    actionType: 'add',
    actionKey: 'assign cro',
    buttonName: 'Assign CRO',
    icon: 'mdi:account-switch-outline',
    isDisabled: ({ row }) => row?.course_enrollment_status !== 1,
    toolTipGetter: ({ row }) =>
      row?.course_enrollment_status === 1
        ? 'Hand this student to an active CRO as a retention lead'
        : 'Make the student active before assigning a CRO',
  },
];

export const STUDENT_STATUS_OPTIONS = [
  { label: 'All', value: 'all' },
  { label: 'Active', value: '1' },
  { label: 'Inactive', value: '0' },
  { label: 'Temporarily Inactive', value: '2' },
];
